import { render, staticRenderFns } from "./TabExtraServicePackage.vue?vue&type=template&id=4b9ddf0a"
import script from "./TabExtraServicePackage.vue?vue&type=script&lang=ts"
export * from "./TabExtraServicePackage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports